export enum NewsStatus {
  PRIMARY = 1,
  SECONDARY = 2,
  INFO = 3,
  DANGER = 4,
  SUCCESS = 5,
  WARNING = 6,
}